import { Inject, Injectable } from '@angular/core';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseApiService {
  protected constructor(
    @Inject('path') protected path: string,
    @Inject('sessionStorageService')
    protected sessionStorageService: SessionStorageService
  ) {}

  get baseUrl(): string {
    const { baseUrl } = this.sessionStorageService.getEnvConfig();
    return `${baseUrl && baseUrl + '/'}${this.path}`;
  }
}
